import { Theme, css } from '@emotion/react';

export const metroAreaContainerWidgetContainer = ({ spacing, breakpoints }: Theme) => css`
  & > * + * {
    margin-left: 0;
    margin-top: ${spacing(2.5)}px;
  }

  ${breakpoints.up('md')} {
    flex-direction: row;

    & > * + * {
      margin-top: 0;
      margin-left: ${spacing(3)}px;
    }
  }
`;

export const metroAreaContainerWidgetItem = (widthPercentage: number) => css`
  display: flex;
  flex-direction: column;
  flex: 1 1 ${widthPercentage}%;

  & > * {
    flex: 1;
  }
`;
